import * as React from "react";
import { StyledStep } from "../../components/ReactTourSteps/ReactTourSteps.styles";

export const tourSteps = [
  {
    selector: ".step-1",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Lesson content</h1>
        <p className="step-text">
          Welcome to your lesson! Make sure you have pens and paper with you and
          work through the lesson by clicking next. You might be asked questions
          as you go, write down your answers or select an on-screen answer.
        </p>
      </StyledStep>
    ),
    style: { background: "#2a2a2a" },
  },
  {
    selector: ".step-2",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Your Performance Learning Pathway</h1>
        <p className="step-text">
          Your Performance Learning Pathway! This is like the content page to
          your lesson, it'll help you know what is coming up so you can be fully
          prepared during your lesson!
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
  {
    selector: ".step-3",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Post-Lesson Assessment</h1>
        <p className="step-text">
          At the end of your lesson I'll ask you some questions. Your answers
          will help me give you an Emotion score, this is important as it helps
          me make sure the lessons on your pathway are still right for you!
        </p>
      </StyledStep>
    ),
    style: {
      background: "#2a2a2a",
    },
  },
];



// WEBPACK FOOTER //
// ./src/pages/SingleLesson/LessonViewTour.tsx